import React from "react";

// Confirmación modal sencilla con dos botones grandes.
export const Confirmar = ({ titulo, texto, cancelar = "Volver", aceptar, peligro, onCancelar, onAceptar, testid }) => (
  <div className="fixed inset-0 z-[95] bg-black/40 flex items-end sm:items-center justify-center p-4" data-testid={testid} role="alertdialog" aria-modal="true">
    <div className="bg-white rounded-3xl p-6 w-full max-w-md space-y-4 shadow-xl">
      <h3 className="font-heading text-xl font-bold text-[#1C2421]">{titulo}</h3>
      {texto && <p className="text-lg text-[#4A5550] leading-relaxed">{texto}</p>}
      <div className="flex flex-col-reverse sm:flex-row gap-3 pt-1">
        <button data-testid={`${testid}-cancelar`} onClick={onCancelar} className="flex-1 min-h-[56px] rounded-2xl bg-[#F2EDE4] border border-[#E5DFD5] text-[#1C2421] font-semibold text-lg">{cancelar}</button>
        <button data-testid={`${testid}-aceptar`} onClick={onAceptar} className={`flex-1 min-h-[56px] rounded-2xl font-bold text-lg text-white ${peligro ? "bg-[#B91C1C]" : "bg-[#3A6B56]"}`}>{aceptar}</button>
      </div>
    </div>
  </div>
);
